export function UnauthenticatedPage() {
  // const login = useAuth((store) => store.login);

  return (
    <div className="p-4 text-white">
      Something went wrong logging you in. Please try again. If the problem persists, contact{' '}
      <a href="mailto:support@metatheory.gg" className="underline">
        support@metatheory.gg
      </a>
      .
    </div>
  );
}
